<div class="ostso-dialog">
  <div class="header">
    <h1>{{ isNew ? "Создание индекса" : "Редактирование индекса" }}</h1>
    <button mat-icon-button class="close-button" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <form [formGroup]="form">
      <input class="remarktype-textarea" matInput [formControlName]="'name'" placeholder="Индекс"/>
      <input class="remarktype-textarea" matInput [formControlName]="'shortName'"
             placeholder="Условное обозначение"/>
      <pas-filling-method [formControlName]="'fillValue'"/>
    </form>
  </div>
  <div mat-dialog-actions>
    <button class="btn btn-blue" mat-button (click)="onApply()" [disabled]="form.invalid">Применить
    </button>
    <button class="btn btn-secondary" mat-button (click)="onNoClick()">Сбросить</button>
  </div>
</div>

